import { EmptyContent, ShowIf } from '@ztechapps/webui.util'
import { NewBom } from './NewBom'
import React from 'react'
import type { ProductBillOfMaterial } from '@ztechapps/common.contract'
import { useToggle } from 'react-use'
import { BusyButton } from '@ztechapps/webui.button'
import { useBillOfMaterialsContext } from './Context'

export type BomEmptyContentProps = {
  parentProductId: string
  billOfMaterials: ProductBillOfMaterial[]
  message?: string
}

export const BomEmptyContent = ({ parentProductId, billOfMaterials, message }: BomEmptyContentProps) => {
  const { canEdit } = useBillOfMaterialsContext()
  const [showAddNew, setShowAddNew] = useToggle(false)

  message = message ?? 'No sub-assembly here yet.'

  return (
    <>
      <EmptyContent
        icon={null}
        message={canEdit ? message : 'You do not have permission to edit this product.'}
        subMessage={canEdit ? "Add one by clicking the 'Add new' button below." : null}
        action={
          <ShowIf condition={canEdit}>
            <BusyButton
              onClick={setShowAddNew}
              title="Add new"
              icon="plus"
              bsStyle={showAddNew ? 'secondary' : 'primary'}
              text={showAddNew ? 'Cancel' : 'Add new'}
            />
          </ShowIf>
        }
      />

      <ShowIf condition={showAddNew}>
        <NewBom productId={parentProductId} billOfMaterials={billOfMaterials} />
      </ShowIf>
    </>
  )
}
